import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
    providedIn:'root'
})
export class DialogService{

    //#region Constructor
    constructor( private dialog: MatDialog){}
    //#endregion Constructor

    //#region Public Methods
    public OpenDialog(component:any, message:string = null): void{
        this.dialog.open(component,{
            disableClose: true,
            width:'500px',
            data : {
                message
            }
        });
    }

    public OpenDialogConfirm(component:any, title:string, subtitle:string, message:string, onConfirm:() => void, onCancel:() => void): void{
        this.dialog.open(component,{
            width:'500px',
            disableClose: true,
            data : {
                title,
                subtitle,
                message,
             }
        })
        .afterClosed().subscribe((result: boolean) => {
            if (result) {
                onConfirm();
            }
            else{
                onCancel();
            }
        });
    }

    public CloseDialog(): void{
        this.dialog.closeAll();
    }

    public OpenDialogFailedRequest(component:any, data:any): void{
        this.dialog.open(component,{
            width:'600px',
            disableClose: true,
            data : data
        });
    }
    //#endregion Public Methods

    //#region Private Methods

    //#endregion Private Methods
}
